export type WidgetLanguage =
  | 'en'
  | 'fr'
  | 'es'
  | 'de'
  | 'pt'
  | 'it'
  | 'tr'
  | 'ar'
  | 'he'
  | 'ru'
  | 'zh-CN'
  | 'ja'
  | 'ko'
  | 'nl';

export const WIDGET_TEXT_KEYS = [
  'Hi',
  'how can I help you?',
  'Click on the question you want to ask',
  'Invalid code. Please try again.',
  "Before we start, Please leave your details so we can stay connected if we're interrupted.",
  'Your Name',
  'Phone Number',
  'I agree to receive updates and marketing messages via WhatsApp.',
  'Verify phone number',
  'Please make sure you typed a valid name and phone number',
  "We've sent a 6-digit code to",
  'Please enter it below to verify your account.',
  'Verify & Start Chat',
  'Verifying...',
  "Didn't get the code?",
  'Resend',
  'Change your phone number',
  'Type a message...',
  'Send',
  'Or we can',
  'Chat on WhatsApp',
  'Click to get help',
  'How would you rate the service we gave you?',
  'Thank you for your feedback!',
  'Start a new Conversation',
  "Perfect - You're verified!",
  "Couldn't connect. Try again?",
  "Connecting you with {name}...",
  "Connecting you with a representative...",
] as const;

const en = {
  'Hi': 'Hi',
  'how can I help you?': 'how can I help you?',
  'Click on the question you want to ask': 'Click on the question you want to ask',
  'Invalid code. Please try again.': 'Invalid code. Please try again.',
  "Before we start, Please leave your details so we can stay connected if we're interrupted.": "Before we start, Please leave your details so we can stay connected if we're interrupted.",
  'Your Name': 'Your Name',
  'Phone Number': 'Phone Number',
  'I agree to receive updates and marketing messages via WhatsApp.': 'I agree to receive updates and marketing messages via WhatsApp.',
  'Verify phone number': 'Verify phone number',
  'Please make sure you typed a valid name and phone number': 'Please make sure you typed a valid name and phone number',
  "We've sent a 6-digit code to": "We've sent a 6-digit code to",
  'Please enter it below to verify your account.': 'Please enter it below to verify your account.',
  'Verify & Start Chat': 'Verify & Start Chat',
  'Verifying...': 'Verifying...',
  "Didn't get the code?": "Didn't get the code?",
  'Resend': 'Resend',
  'Change your phone number': 'Change your phone number',
  'Type a message...': 'Type a message...',
  'Send': 'Send',
  'Or we can': 'Or we can',
  'Chat on WhatsApp': 'Chat on WhatsApp',
  'Click to get help': 'Click to get help',
  'How would you rate the service we gave you?': 'How would you rate the service we gave you?',
  'Thank you for your feedback!': 'Thank you for your feedback!',
  'Start a new Conversation': 'Start a new Conversation',
  "Perfect - You're verified!": "Perfect - You're verified!",
  "Couldn't connect. Try again?": "Couldn't connect. Try again?",
  'Connecting you with a representative...': 'Connecting you with a representative...',
  'Connecting you with {name}...': 'Connecting you with {name}...',
};

export const WIDGET_LANGUAGE_CONFIG: Record<WidgetLanguage, { label: string; flag: string; direction: 'ltr' | 'rtl'; translations: Record<string, string> }> = {
  en: { label: 'English', direction: 'ltr', translations: en, flag: '🇺🇸' },
  fr: {
    label: 'French',
    flag: '🇫🇷',
    direction: 'ltr',
    translations: {
      'Hi': 'Bonjour',
      'how can I help you?': 'comment puis-je vous aider ?',
      'Click on the question you want to ask': 'Cliquez sur la question que vous souhaitez poser',
      'Invalid code. Please try again.': 'Code invalide. Veuillez réessayer.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Avant de commencer, laissez vos coordonnées pour que nous puissions rester en contact si la conversation est interrompue.',
      'Your Name': 'Votre nom',
      'Phone Number': 'Numéro de téléphone',
      'I agree to receive updates and marketing messages via WhatsApp.': 'J’accepte de recevoir des mises à jour et des messages marketing via WhatsApp.',
      'Verify phone number': 'Vérifier le numéro de téléphone',
      'Please make sure you typed a valid name and phone number': 'Veuillez saisir un nom et un numéro de téléphone valides',
      "We've sent a 6-digit code to": 'Nous avons envoyé un code à 6 chiffres au',
      'Please enter it below to verify your account.': 'Veuillez le saisir ci-dessous pour vérifier votre compte.',
      'Verify & Start Chat': 'Vérifier et démarrer le chat',
      'Verifying...': 'Vérification...',
      "Didn't get the code?": 'Vous n’avez pas reçu le code ?',
      'Resend': 'Renvoyer',
      'Change your phone number': 'Changer votre numéro de téléphone',
      'Type a message...': 'Écrivez un message...',
      'Send': 'Envoyer',
      'Or we can': 'Ou vous pouvez',
      'Chat on WhatsApp': 'discuter sur WhatsApp',
      'Click to get help': 'Cliquez pour obtenir de l’aide',
      'How would you rate the service we gave you?': 'Comment évalueriez-vous le service que nous vous avons fourni ?',
      'Thank you for your feedback!': 'Merci pour votre retour !',
      'Start a new Conversation': 'Démarrer une nouvelle conversation',
      "Perfect - You're verified!": 'Parfait, vous êtes vérifié !',
      "Couldn't connect. Try again?": 'Connexion impossible. Réessayer ?',
      'Connecting you with a representative...': 'Connexion avec un representant...',
      'Connecting you with {name}...': 'Connexion avec {name}...',
    },
  },
  es: {
    label: 'Spanish',
    flag: '🇪🇸',
    direction: 'ltr',
    translations: {
      'Hi': 'Hola',
      'how can I help you?': '¿cómo puedo ayudarte?',
      'Click on the question you want to ask': 'Haz clic en la pregunta que quieres hacer',
      'Invalid code. Please try again.': 'El código no es válido. Inténtalo de nuevo.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Antes de empezar, deja tus datos para que podamos seguir en contacto si se interrumpe la conversación.',
      'Your Name': 'Tu nombre',
      'Phone Number': 'Número de teléfono',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Acepto recibir actualizaciones y mensajes de marketing por WhatsApp.',
      'Verify phone number': 'Verificar número de teléfono',
      'Please make sure you typed a valid name and phone number': 'Asegúrate de ingresar un nombre y número de teléfono válidos',
      "We've sent a 6-digit code to": 'Hemos enviado un código de 6 dígitos a',
      'Please enter it below to verify your account.': 'Ingresa el código para verificar tu cuenta.',
      'Verify & Start Chat': 'Verificar e iniciar chat',
      'Verifying...': 'Verificando...',
      "Didn't get the code?": '¿No recibiste el código?',
      'Resend': 'Reenviar',
      'Change your phone number': 'Cambiar tu número de teléfono',
      'Type a message...': 'Escribe un mensaje...',
      'Send': 'Enviar',
      'Or we can': 'O también puedes',
      'Chat on WhatsApp': 'chatear por WhatsApp',
      'Click to get help': 'Haz clic para obtener ayuda',
      'How would you rate the service we gave you?': '¿Cómo calificarías el servicio que te brindamos?',
      'Thank you for your feedback!': '¡Gracias por tus comentarios!',
      'Start a new Conversation': 'Iniciar una nueva conversación',
      "Perfect - You're verified!": 'Perfecto: ya estás verificado.',
      "Couldn't connect. Try again?": 'No se pudo conectar. ¿Intentar de nuevo?',
      'Connecting you with a representative...': 'Conectándote con un representante...',
      'Connecting you with {name}...': 'Conectándote con {name}...',
    },
  },
  de: {
    label: 'German',
    flag: '🇩🇪',
    direction: 'ltr',
    translations: {
      'Hi': 'Hallo',
      'how can I help you?': 'wie kann ich dir helfen?',
      'Click on the question you want to ask': 'Klicke auf die Frage, die du stellen möchtest',
      'Invalid code. Please try again.': 'Ungültiger Code. Bitte versuche es erneut.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Bevor wir beginnen, hinterlasse bitte deine Kontaktdaten, damit wir in Verbindung bleiben können, falls die Unterhaltung unterbrochen wird.',
      'Your Name': 'Dein Name',
      'Phone Number': 'Telefonnummer',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Ich stimme zu, Updates und Marketingnachrichten über WhatsApp zu erhalten.',
      'Verify phone number': 'Telefonnummer verifizieren',
      'Please make sure you typed a valid name and phone number': 'Bitte gib einen gültigen Namen und eine gültige Telefonnummer ein',
      "We've sent a 6-digit code to": 'Wir haben einen 6-stelligen Code gesendet an',
      'Please enter it below to verify your account.': 'Bitte gib ihn unten ein, um dein Konto zu bestätigen.',
      'Verify & Start Chat': 'Verifizieren und Chat starten',
      'Verifying...': 'Wird überprüft...',
      "Didn't get the code?": 'Code nicht erhalten?',
      'Resend': 'Erneut senden',
      'Change your phone number': 'Telefonnummer ändern',
      'Type a message...': 'Nachricht eingeben...',
      'Send': 'Senden',
      'Or we can': 'Oder du kannst',
      'Chat on WhatsApp': 'auf WhatsApp chatten',
      'Click to get help': 'Klicke, um Hilfe zu erhalten',
      'How would you rate the service we gave you?': 'Wie würdest du den Service bewerten, den wir dir gegeben haben?',
      'Thank you for your feedback!': 'Danke für dein Feedback!',
      'Start a new Conversation': 'Neue Unterhaltung starten',
      "Perfect - You're verified!": 'Perfekt – du bist verifiziert!',
      "Couldn't connect. Try again?": 'Verbindung fehlgeschlagen. Erneut versuchen?',
      'Connecting you with a representative...': 'Wir verbinden dich mit einem Mitarbeiter...',
      'Connecting you with {name}...': 'Wir verbinden dich mit {name}...',
    },
  },
  pt: {
    label: 'Portuguese',
    flag: '🇵🇹',
    direction: 'ltr',
    translations: {
      'Hi': 'Olá',
      'how can I help you?': 'como posso ajudar?',
      'Click on the question you want to ask': 'Clique na pergunta que deseja fazer',
      'Invalid code. Please try again.': 'Código inválido. Tente novamente.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Antes de começar, deixe seus dados para que possamos continuar em contato se a conversa for interrompida.',
      'Your Name': 'Seu nome',
      'Phone Number': 'Número de telefone',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Concordo em receber atualizações e mensagens de marketing pelo WhatsApp.',
      'Verify phone number': 'Verificar número de telefone',
      'Please make sure you typed a valid name and phone number': 'Verifique se digitou um nome e número de telefone válidos',
      "We've sent a 6-digit code to": 'Enviamos um código de 6 dígitos para',
      'Please enter it below to verify your account.': 'Digite-o abaixo para verificar sua conta.',
      'Verify & Start Chat': 'Verificar e iniciar chat',
      'Verifying...': 'Verificando...',
      "Didn't get the code?": 'Não recebeu o código?',
      'Resend': 'Reenviar',
      'Change your phone number': 'Alterar seu número de telefone',
      'Type a message...': 'Digite uma mensagem...',
      'Send': 'Enviar',
      'Or we can': 'Ou você pode',
      'Chat on WhatsApp': 'conversar no WhatsApp',
      'Click to get help': 'Clique para obter ajuda',
      'How would you rate the service we gave you?': 'Como você avaliaria o serviço que prestamos?',
      'Thank you for your feedback!': 'Obrigado pelo seu feedback!',
      'Start a new Conversation': 'Iniciar uma nova conversa',
      "Perfect - You're verified!": 'Perfeito — você foi verificado!',
      "Couldn't connect. Try again?": 'Não foi possível conectar. Tentar novamente?',
      'Connecting you with a representative...': 'Conectando você com um representante...',
      'Connecting you with {name}...': 'Conectando você com {name}...',
    },
  },
  it: {
    label: 'Italian',
    flag: '🇮🇹',
    direction: 'ltr',
    translations: {
      'Hi': 'Ciao',
      'how can I help you?': 'come posso aiutarti?',
      'Click on the question you want to ask': 'Fai clic sulla domanda che vuoi porre',
      'Invalid code. Please try again.': 'Codice non valido. Riprova.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Prima di iniziare, lascia i tuoi dati così possiamo restare in contatto se la conversazione si interrompe.',
      'Your Name': 'Il tuo nome',
      'Phone Number': 'Numero di telefono',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Accetto di ricevere aggiornamenti e messaggi di marketing via WhatsApp.',
      'Verify phone number': 'Verifica numero di telefono',
      'Please make sure you typed a valid name and phone number': 'Assicurati di aver inserito un nome e un numero di telefono validi',
      "We've sent a 6-digit code to": 'Abbiamo inviato un codice di 6 cifre a',
      'Please enter it below to verify your account.': 'Inseriscilo qui sotto per verificare il tuo account.',
      'Verify & Start Chat': 'Verifica e avvia chat',
      'Verifying...': 'Verifica in corso...',
      "Didn't get the code?": 'Non hai ricevuto il codice?',
      'Resend': 'Invia di nuovo',
      'Change your phone number': 'Cambia il tuo numero di telefono',
      'Type a message...': 'Scrivi un messaggio...',
      'Send': 'Invia',
      'Or we can': 'Oppure puoi',
      'Chat on WhatsApp': 'chattare su WhatsApp',
      'Click to get help': 'Clicca per ricevere aiuto',
      'How would you rate the service we gave you?': 'Come valuteresti il servizio che ti abbiamo fornito?',
      'Thank you for your feedback!': 'Grazie per il tuo feedback!',
      'Start a new Conversation': 'Inizia una nuova conversazione',
      "Perfect - You're verified!": 'Perfetto: sei verificato!',
      "Couldn't connect. Try again?": 'Impossibile connettersi. Riprovi?',
      'Connecting you with a representative...': 'Ti stiamo mettendo in contatto con un operatore...',
      'Connecting you with {name}...': 'Ti stiamo mettendo in contatto con {name}...',
    },
  },
  tr: {
    label: 'Turkish',
    flag: '🇹🇷',
    direction: 'ltr',
    translations: {
      'Hi': 'Merhaba',
      'how can I help you?': 'nasıl yardımcı olabilirim?',
      'Click on the question you want to ask': 'Sormak istediğiniz soruya tıklayın',
      'Invalid code. Please try again.': 'Kod geçersiz. Lütfen tekrar deneyin.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Başlamadan önce, konuşma kesilirse bağlantıda kalabilmemiz için bilgilerinizi bırakın.',
      'Your Name': 'Adınız',
      'Phone Number': 'Telefon numarası',
      'I agree to receive updates and marketing messages via WhatsApp.': 'WhatsApp üzerinden güncellemeler ve pazarlama mesajları almayı kabul ediyorum.',
      'Verify phone number': 'Telefon numarasını doğrula',
      'Please make sure you typed a valid name and phone number': 'Lütfen geçerli bir ad ve telefon numarası girdiğinizden emin olun',
      "We've sent a 6-digit code to": 'Şu numaraya 6 haneli bir kod gönderdik',
      'Please enter it below to verify your account.': 'Hesabınızı doğrulamak için lütfen aşağıya girin.',
      'Verify & Start Chat': 'Doğrula ve sohbeti başlat',
      'Verifying...': 'Doğrulanıyor...',
      "Didn't get the code?": 'Kodu almadınız mı?',
      'Resend': 'Yeniden gönder',
      'Change your phone number': 'Telefon numaranızı değiştirin',
      'Type a message...': 'Bir mesaj yazın...',
      'Send': 'Gönder',
      'Or we can': 'Ya da',
      'Chat on WhatsApp': 'WhatsApp üzerinden yazışabiliriz',
      'Click to get help': 'Yardım almak için tıklayın',
      'How would you rate the service we gave you?': 'Size sunduğumuz hizmeti nasıl değerlendirirsiniz?',
      'Thank you for your feedback!': 'Geri bildiriminiz için teşekkürler!',
      'Start a new Conversation': 'Yeni bir konuşma başlat',
      "Perfect - You're verified!": 'Harika — doğrulamanız tamamlandı!',
      "Couldn't connect. Try again?": 'Bağlanılamadı. Tekrar denensin mi?',
      'Connecting you with a representative...': 'Seni bir temsilciye bağlıyoruz...',
      'Connecting you with {name}...': 'Seni {name} ile bağlıyoruz...',
    },
  },
  ar: {
    label: 'Arabic',
    flag: '🇸🇦',
    direction: 'rtl',
    translations: {
      'Hi': 'مرحبًا',
      'how can I help you?': 'كيف يمكنني مساعدتك؟',
      'Click on the question you want to ask': 'اضغط على السؤال الذي تريد طرحه',
      'Invalid code. Please try again.': 'الرمز غير صحيح. حاول مرة أخرى.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'قبل أن نبدأ، اترك تفاصيلك حتى نبقى على تواصل إذا انقطعت المحادثة.',
      'Your Name': 'اسمك',
      'Phone Number': 'رقم الهاتف',
      'I agree to receive updates and marketing messages via WhatsApp.': 'أوافق على تلقي التحديثات والرسائل التسويقية عبر واتساب.',
      'Verify phone number': 'تحقق من رقم الهاتف',
      'Please make sure you typed a valid name and phone number': 'يرجى التأكد من إدخال اسم ورقم هاتف صحيحين',
      "We've sent a 6-digit code to": 'لقد أرسلنا رمزًا مكونًا من 6 أرقام إلى',
      'Please enter it below to verify your account.': 'يرجى إدخاله أدناه لتأكيد حسابك.',
      'Verify & Start Chat': 'تحقق وابدأ المحادثة',
      'Verifying...': 'جارٍ التحقق...',
      "Didn't get the code?": 'لم يصلك الرمز؟',
      'Resend': 'إعادة الإرسال',
      'Change your phone number': 'تغيير رقم الهاتف',
      'Type a message...': 'اكتب رسالة...',
      'Send': 'إرسال',
      'Or we can': 'أو يمكنك',
      'Chat on WhatsApp': 'المحادثة عبر واتساب',
      'Click to get help': 'اضغط للحصول على المساعدة',
      'How would you rate the service we gave you?': 'كيف تقيّم الخدمة التي قدمناها لك؟',
      'Thank you for your feedback!': 'شكرًا على ملاحظاتك!',
      'Start a new Conversation': 'ابدأ محادثة جديدة',
      "Perfect - You're verified!": 'ممتاز - تم التحقق منك!',
      "Couldn't connect. Try again?": 'تعذر الاتصال. هل تريد المحاولة مرة أخرى؟',
      'Connecting you with a representative...': 'جارٍ تحويلك إلى أحد الممثلين...',
      'Connecting you with {name}...': 'جارٍ تحويلك إلى {name}...',
    },
  },
  he: {
    label: 'Hebrew',
    flag: '🇮🇱',
    direction: 'rtl',
    translations: {
      'Hi': 'היי',
      'how can I help you?': 'איך אוכל לעזור?',
      'Click on the question you want to ask': 'לחצו על השאלה שתרצו לשאול',
      'Invalid code. Please try again.': 'הקוד לא תקין. נסו שוב.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'לפני שנתחיל, השאירו את הפרטים שלכם כדי שנוכל להישאר בקשר אם השיחה תופרע.',
      'Your Name': 'השם שלך',
      'Phone Number': 'מספר טלפון',
      'I agree to receive updates and marketing messages via WhatsApp.': 'אני מאשר/ת לקבל עדכונים והודעות שיווקיות בוואטסאפ.',
      'Verify phone number': 'אמתו את מספר הטלפון',
      'Please make sure you typed a valid name and phone number': 'ודאו שהזנתם שם ומספר טלפון תקינים',
      "We've sent a 6-digit code to": 'שלחנו קוד בן 6 ספרות אל',
      'Please enter it below to verify your account.': 'הזינו אותו כאן כדי לאמת את החשבון שלכם.',
      'Verify & Start Chat': 'אמתו והתחילו בצ׳אט',
      'Verifying...': 'מאמתים...',
      "Didn't get the code?": 'לא קיבלתם את הקוד?',
      'Resend': 'שלחו שוב',
      'Change your phone number': 'שנו את מספר הטלפון',
      'Type a message...': 'כתבו הודעה...',
      'Send': 'שליחה',
      'Or we can': 'או שאפשר',
      'Chat on WhatsApp': 'להמשיך בוואטסאפ',
      'Click to get help': 'לחצו לקבלת עזרה',
      'How would you rate the service we gave you?': 'איך הייתם מדרגים את השירות שקיבלתם?',
      'Thank you for your feedback!': 'תודה על המשוב שלכם!',
      'Start a new Conversation': 'התחילו שיחה חדשה',
      "Perfect - You're verified!": 'מעולה - האימות הושלם!',
      "Couldn't connect. Try again?": 'לא הצלחנו להתחבר. לנסות שוב?',
      'Connecting you with a representative...': 'מעביר אותך לנציג...',
      'Connecting you with {name}...': 'מעביר אותך אל {name}...',
    },
  },
  ru: {
    label: 'Russian',
    flag: '🇷🇺',
    direction: 'ltr',
    translations: {
      'Hi': 'Здравствуйте',
      'how can I help you?': 'чем могу помочь?',
      'Click on the question you want to ask': 'Нажмите на вопрос, который хотите задать',
      'Invalid code. Please try again.': 'Неверный код. Попробуйте еще раз.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Перед началом оставьте свои данные, чтобы мы могли продолжить общение, если разговор прервется.',
      'Your Name': 'Ваше имя',
      'Phone Number': 'Номер телефона',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Я согласен получать обновления и маркетинговые сообщения через WhatsApp.',
      'Verify phone number': 'Подтвердить номер телефона',
      'Please make sure you typed a valid name and phone number': 'Пожалуйста, проверьте, что вы ввели корректное имя и номер телефона',
      "We've sent a 6-digit code to": 'Мы отправили 6-значный код на номер',
      'Please enter it below to verify your account.': 'Введите его ниже, чтобы подтвердить аккаунт.',
      'Verify & Start Chat': 'Подтвердить и начать чат',
      'Verifying...': 'Проверяем...',
      "Didn't get the code?": 'Не получили код?',
      'Resend': 'Отправить снова',
      'Change your phone number': 'Изменить номер телефона',
      'Type a message...': 'Введите сообщение...',
      'Send': 'Отправить',
      'Or we can': 'Или можно',
      'Chat on WhatsApp': 'написать в WhatsApp',
      'Click to get help': 'Нажмите, чтобы получить помощь',
      'How would you rate the service we gave you?': 'Как бы вы оценили оказанный сервис?',
      'Thank you for your feedback!': 'Спасибо за ваш отзыв!',
      'Start a new Conversation': 'Начать новый диалог',
      "Perfect - You're verified!": 'Отлично — вы подтверждены!',
      "Couldn't connect. Try again?": 'Не удалось подключиться. Попробовать еще раз?',
      'Connecting you with a representative...': 'Соединяем вас с представителем...',
      'Connecting you with {name}...': 'Соединяем вас с {name}...',
    },
  },
  'zh-CN': {
    label: 'Chinese (Simplified)',
    flag: '🇨🇳',
    direction: 'ltr',
    translations: {
      'Hi': '你好',
      'how can I help you?': '我可以帮你什么？',
      'Click on the question you want to ask': '点击你想提问的问题',
      'Invalid code. Please try again.': '验证码无效，请重试。',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": '在开始之前，请留下你的信息，这样如果聊天中断我们仍可保持联系。',
      'Your Name': '你的姓名',
      'Phone Number': '电话号码',
      'I agree to receive updates and marketing messages via WhatsApp.': '我同意通过 WhatsApp 接收更新和营销消息。',
      'Verify phone number': '验证电话号码',
      'Please make sure you typed a valid name and phone number': '请输入有效的姓名和电话号码',
      "We've sent a 6-digit code to": '我们已向以下号码发送 6 位验证码',
      'Please enter it below to verify your account.': '请在下方输入以验证你的账户。',
      'Verify & Start Chat': '验证并开始聊天',
      'Verifying...': '正在验证...',
      "Didn't get the code?": '没有收到验证码？',
      'Resend': '重新发送',
      'Change your phone number': '更改电话号码',
      'Type a message...': '输入消息...',
      'Send': '发送',
      'Or we can': '或者你也可以',
      'Chat on WhatsApp': '通过 WhatsApp 聊天',
      'Click to get help': '点击获取帮助',
      'How would you rate the service we gave you?': '你如何评价我们提供的服务？',
      'Thank you for your feedback!': '感谢你的反馈！',
      'Start a new Conversation': '开始新的对话',
      "Perfect - You're verified!": '很好，验证已完成！',
      "Couldn't connect. Try again?": '无法连接。再试一次？',
    },
  },
  ja: {
    label: 'Japanese',
    flag: '🇯🇵',
    direction: 'ltr',
    translations: {
      'Hi': 'こんにちは',
      'how can I help you?': 'どのようにお手伝いできますか？',
      'Click on the question you want to ask': '質問したい項目をクリックしてください',
      'Invalid code. Please try again.': 'コードが無効です。もう一度お試しください。',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": '開始する前に、会話が途切れても連絡を続けられるよう情報を残してください。',
      'Your Name': 'お名前',
      'Phone Number': '電話番号',
      'I agree to receive updates and marketing messages via WhatsApp.': 'WhatsAppで更新情報やマーケティングメッセージを受け取ることに同意します。',
      'Verify phone number': '電話番号を確認',
      'Please make sure you typed a valid name and phone number': '有効な名前と電話番号を入力してください',
      "We've sent a 6-digit code to": '6桁のコードを次の番号に送信しました',
      'Please enter it below to verify your account.': 'アカウント確認のため、以下に入力してください。',
      'Verify & Start Chat': '確認してチャットを開始',
      'Verifying...': '確認中...',
      "Didn't get the code?": 'コードが届きませんか？',
      'Resend': '再送信',
      'Change your phone number': '電話番号を変更',
      'Type a message...': 'メッセージを入力...',
      'Send': '送信',
      'Or we can': 'または',
      'Chat on WhatsApp': 'WhatsAppでチャット',
      'Click to get help': 'クリックしてサポートを受ける',
      'How would you rate the service we gave you?': '今回のサービスをどのように評価しますか？',
      'Thank you for your feedback!': 'フィードバックありがとうございます！',
      'Start a new Conversation': '新しい会話を始める',
      "Perfect - You're verified!": '確認が完了しました！',
      "Couldn't connect. Try again?": '接続できませんでした。もう一度試しますか？',
      'Connecting you with a representative...': '担当者におつなぎしています...',
      'Connecting you with {name}...': '{name} におつなぎしています...',
    },
  },
  ko: {
    label: 'Korean',
    flag: '🇰🇷',
    direction: 'ltr',
    translations: {
      'Hi': '안녕하세요',
      'how can I help you?': '어떻게 도와드릴까요?',
      'Click on the question you want to ask': '질문하고 싶은 항목을 클릭하세요',
      'Invalid code. Please try again.': '코드가 올바르지 않습니다. 다시 시도해 주세요.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": '시작하기 전에 대화가 끊겨도 계속 연락할 수 있도록 정보를 남겨 주세요.',
      'Your Name': '이름',
      'Phone Number': '전화번호',
      'I agree to receive updates and marketing messages via WhatsApp.': 'WhatsApp을 통해 업데이트 및 마케팅 메시지를 받는 데 동의합니다.',
      'Verify phone number': '전화번호 확인',
      'Please make sure you typed a valid name and phone number': '유효한 이름과 전화번호를 입력해 주세요',
      "We've sent a 6-digit code to": '다음 번호로 6자리 코드를 보냈습니다',
      'Please enter it below to verify your account.': '계정을 확인하려면 아래에 입력해 주세요.',
      'Verify & Start Chat': '확인 후 채팅 시작',
      'Verifying...': '확인 중...',
      "Didn't get the code?": '코드를 받지 못하셨나요?',
      'Resend': '다시 보내기',
      'Change your phone number': '전화번호 변경',
      'Type a message...': '메시지를 입력하세요...',
      'Send': '보내기',
      'Or we can': '또는',
      'Chat on WhatsApp': 'WhatsApp으로 채팅',
      'Click to get help': '도움 받으려면 클릭하세요',
      'How would you rate the service we gave you?': '저희 서비스는 어떠셨나요?',
      'Thank you for your feedback!': '소중한 의견 감사합니다!',
      'Start a new Conversation': '새 대화 시작',
      "Perfect - You're verified!": '확인이 완료되었습니다!',
      "Couldn't connect. Try again?": '연결할 수 없습니다. 다시 시도하시겠습니까?',
      'Connecting you with a representative...': '상담원에게 연결하고 있습니다...',
      'Connecting you with {name}...': '{name}님에게 연결하고 있습니다...',
    },
  },
  nl: {
    label: 'Dutch',
    flag: '🇳🇱',
    direction: 'ltr',
    translations: {
      'Hi': 'Hoi',
      'how can I help you?': 'hoe kan ik je helpen?',
      'Click on the question you want to ask': 'Klik op de vraag die je wilt stellen',
      'Invalid code. Please try again.': 'Ongeldige code. Probeer het opnieuw.',
      "Before we start, Please leave your details so we can stay connected if we're interrupted.": 'Laat voordat we beginnen je gegevens achter, zodat we contact kunnen houden als het gesprek wordt onderbroken.',
      'Your Name': 'Je naam',
      'Phone Number': 'Telefoonnummer',
      'I agree to receive updates and marketing messages via WhatsApp.': 'Ik ga akkoord met het ontvangen van updates en marketingberichten via WhatsApp.',
      'Verify phone number': 'Telefoonnummer verifiëren',
      'Please make sure you typed a valid name and phone number': 'Controleer of je een geldige naam en telefoonnummer hebt ingevuld',
      "We've sent a 6-digit code to": 'We hebben een 6-cijferige code gestuurd naar',
      'Please enter it below to verify your account.': 'Voer deze hieronder in om je account te verifiëren.',
      'Verify & Start Chat': 'Verifiëren en chat starten',
      'Verifying...': 'Bezig met verifiëren...',
      "Didn't get the code?": 'Geen code ontvangen?',
      'Resend': 'Opnieuw verzenden',
      'Change your phone number': 'Je telefoonnummer wijzigen',
      'Type a message...': 'Typ een bericht...',
      'Send': 'Versturen',
      'Or we can': 'Of we kunnen',
      'Chat on WhatsApp': 'chatten via WhatsApp',
      'Click to get help': 'Klik voor hulp',
      'How would you rate the service we gave you?': 'Hoe zou je de service beoordelen die we hebben gegeven?',
      'Thank you for your feedback!': 'Bedankt voor je feedback!',
      'Start a new Conversation': 'Nieuw gesprek starten',
      "Perfect - You're verified!": 'Perfect — je bent geverifieerd!',
      "Couldn't connect. Try again?": 'Kon geen verbinding maken. Opnieuw proberen?',
      'Connecting you with a representative...': 'We verbinden je met een medewerker...',
      'Connecting you with {name}...': 'We verbinden je met {name}...',
    },
  },
};

export const getWidgetLocaleConfig = (language: WidgetLanguage) => WIDGET_LANGUAGE_CONFIG[language] || WIDGET_LANGUAGE_CONFIG.en;
